import { Button } from 'semantic-ui-react';
import styled, { css } from 'styled-components';

// Workaround until we move on from semantic ui
const StyledButton = styled(Button)<{
  $destructive: boolean;
  $disabled: boolean;
}>`
  &&&&& {
    width: 100%;
    text-align: start;
    font-size: 14px;
    &:hover {
      background: ${({ theme }) => theme.colors.backgroundHover} !important;
    }

    ${({ $destructive, theme }) =>
      `color: ${$destructive ? '#f95050' : theme.colors.text} !important;`}

    ${({ $disabled }) =>
      $disabled
        ? css`
            opacity: 0.6;
            pointer-events: none;
          `
        : ``}
  }
`;

export const Styled = {
  Button: StyledButton,
};
